import React, {
  Fragment,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useHistory, useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import NumberFormat from "react-number-format";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import CartContext from "../../context/cart/CartContext";
import EmployeeContext from "../../context/employee/EmployeeContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import ActionMenu from "../layout/ActionMenu";
import Preloader from "../layout/Preloader";
import DataInputTable from "../common/DataInputTable";
import SearchMenu from "../common/SearchMenu";
import ModalDialog from "../common/ModalDialog";
import PopupMessage from "../common/PopupMessage";
import useTokenCheck from "../../hooks/useTokenCheck";
import useForm from "../../hooks/useForm";

const SponsorRecharge = (props) => {
  const authContext = useContext(AuthContext);
  const { token } = authContext;
  const configContext = useContext(ConfigContext);
  const {
    loaded,
    getConfigValue,
    getConfigValueByCode,
    getConfigValueByNameSponser,
  } = configContext;
  const alertContext = useContext(AlertContext);
  const { setAlert, clearAlerts } = alertContext;
  const cardContext = useContext(CardContext);
  const cartContext = useContext(CartContext);
  const employeeContext = useContext(EmployeeContext);
  const navigationContext = useContext(NavigationContext);
  const {
    rechargeCards,
    getRechargeCards,
    rechargeLoading,
    loadCard,
    isLoading,
    updateRechargeCards,
    loadContract,
    resetCardState,
  } = cardContext;
  const { navigationBack, resetNavigationState } = navigationContext;
  const {
    addItems,
    loading: cartLoading,
    loaded: cartLoaded,
    loadItems,
    error,
  } = cartContext;
  const { employeesLoading, loadEmployee } = employeeContext;
  const history = useHistory();
  const [msgDisplayTime, setMsgDisplayTime] = useState(1000);
  const [itemsInCart, setItemsInCart] = useState(false);
  const rechargeAmountRef = useRef(null);
  let cardData, pages;
  if (rechargeCards) {
    cardData = rechargeCards.data;
    pages = {
      numberOfPages: rechargeCards.numberOfPages,
      pageNumber: rechargeCards.pageNumber,
      numberOfRecords: rechargeCards.numberOfRecords,
    };
  }
  const { hasTokenExpired } = useTokenCheck();
  const location = useLocation();

  useEffect(() => {
    console.log("checking navigation", navigationBack, searchCriteria);
    if (navigationBack) {
      console.log("setingInitLoad", true);
      setShowData(true);
      resetNavigationState();
    } else {
      console.log("RESETing RS Recharge");
      // setShowData(false);
      resetCardState();
      setCurrentData([]);
      clearAlerts();
    }
    if (loaded) {
      const pageSize = getConfigValue(
        "generalConfig",
        "page_size",
        "App_Config"
      );
      setPageSize(pageSize);
      const msgDisplayTime =
        getConfigValue(
          "generalConfig",
          "Message_Display_Duration",
          "App_Config"
        ) * 1000;
      setMsgDisplayTime(msgDisplayTime);
    }
    //eslint-disable-next-line
  }, []);

  const [showTooltip, setShowTooltip] = useState(false);
  const [fieldRef, setFieldRef] = useState(null);
  const [validationMessage, setValidationMessage] = useState(null);
  const [pageSize, setPageSize] = useState(25);
  const [filteredRows, setFilteredRows] = useState();

  const TablePopup = (props) => {
    if (fieldRef) {
      return (
        <PopupMessage
          {...props}
          show={showTooltip}
          message={validationMessage}
          target={fieldRef}
        />
      );
    } else return "";
  };

  const [searchCriteria, setSearchCriteria] = useState({
    filterType: "",
    filterValue: "",
  });
  const [reloadSearch, setReloadSearch] = useState(false);
  const [showData, setShowData] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rechargeValueAll, setRechargeValueAll] = useState("");
  // const { searchBy, searchByValue, fromPeriod, toPeriod, enableInput } = search;
  //   const { filterType, filterValue } = searchCriteria;
  const [showDialog, setShowDialog] = useState(false);
  const [isTableValid, setIsTableValid] = useState(false);

  const onClose = () => {
    setShowDialog(false);
    setReloadSearch(true);
  };

  const getEntityId = (rowIndex, entityField) => {
    let rowData = [];
    if (cardData)
      rowData = cardData.filter((item, index) => {
        console.log("Row", index, "input:", rowIndex);
        return index === rowIndex;
      });
    console.log("seleted Row", rowData);
    return rowData[0][entityField];
  };

  const loadPageData = async (pageNo, criteria) => {
    console.log("LOAD", pageNo, criteria);
    try {
      const { filterType } = searchCriteria;
      if (!criteria) {
        if (filterType === "") {
          criteria = {
            filterType: "all",
          };
        } else {
          criteria = searchCriteria;
        }
      }
      console.log("###Criteria: ", searchCriteria);
      const res = await getRechargeCards({ ...criteria, pageNo }, token);
      console.log("$$RES: ", res);
      if (res && res.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        setCurrentData([]);
        setShowData(false);
        clearAlerts();
        setAlert(msg, "danger");
      } else {
        setCurrentPage(pageNo);
        setShowData(true);
        setTableAlert(
          "Search is successfully completed and matching records are displayed in the table"
        );
      }
    } catch (err) {
      console.log("$ERR:", err);
      if (err.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          err.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      }
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  // const getFormattedObject = (orders) => {
  //   if (!orders) return [];
  //   return orders.map((order) => {
  //     return {
  //       ...order,
  //       creationDate: moment
  //         .utc(order.creationDate)
  //         .tz("America/Chicago")
  //         .format("MM/DD/YYYY hh:mm A"),
  //       price: `$ ${(order.price / 100).toFixed(2)}`,
  //     };
  //   });
  // };

  useEffect(() => {
    if (reloadSearch) {
      // const criteria = { ...searchCriteria };
      // delete criteria["enableInput"];
      // console.log("Search reloading::::", criteria);
      // const { filterType: searchBy, filterValue: searchByValue } = criteria;
      searchCards(searchCriteria, currentPage);
      setReloadSearch(false);
    }
    //eslint-disable-next-line
  }, [reloadSearch]);

  const updateChangedData = (data) => {
    console.log("DATA CHANGED");
    updateRechargeCards(data);
  };
  //setCurrentCard
  const selectCurrentCard = async (card) => {
    await hasTokenExpired();
    try {
      await loadCard({ cardnumber: card }, token);
      history.push("/home/mycard-details");
    } catch (err) {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  //setCurrentContract
  const selectCurrentContract = async (rowIndex) => {
    await hasTokenExpired();
    try {
      const contractId = getEntityId(rowIndex, "contractId");
      console.log("ContractID", contractId);
      await loadContract({ contractId: contractId }, token);
      history.push("/contract-detail");
    } catch (err) {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  //setCurrentCard
  const selectCurrentEmployee = async (rowIndex) => {
    await hasTokenExpired();
    try {
      const emp = getEntityId(rowIndex, "empId");
      // employeeDispatch({
      //   type: SET_CURRENT_EMPLOYEE,
      //   payload: employeeId,
      // });
      await loadEmployee({ id: emp }, token);
      history.push("/employee-detail", { prevPath: location.pathname });
    } catch (err) {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const searchCards = async (criteria, page) => {
    setTableAlert(" ");
    console.log("###Criteria: ", criteria);
    const { filterType, filterValue } = criteria;
    let searchCriteria = {};
    searchCriteria = {
      filterType: filterType === "" ? "all" : filterType,
    };
    if (filterValue !== "") {
      searchCriteria = {
        ...searchCriteria,
        filterValue: filterValue,
      };
    }
    setSearchCriteria((prevCriteria) => ({
      ...prevCriteria,
      ...searchCriteria,
    }));
    // setSearchCriteria({ ...searchCriteria });
    // console.log("$$Criteria: ", filterCriteria);
    console.log("$$$Criteria: ", searchCriteria);
    loadPageData(page ? page : 0, searchCriteria);
  };

  const getChangedCards = () => {
    console.log("#####CHANGE CARDS:", currentData);
    return currentData
      .filter((item) => {
        console.log("Item amount ", item.amount, " Check:", item.amount > 0);
        return item.amount > 0;
      })
      .map((item) => {
        return {
          employeeId: item.employeeId,
          contractid: item.contractId,
          rechargevalue: item.amount * 100,
        };
      });
  };

  const onSaveToCart = async (e) => {
    //Get changed Data Set
    const payload = { rechargeCards: getChangedCards() };
    //post add items to cart
    console.log("Payload...", payload);
    try {
      const res = await addItems(payload, token);
      //clear cards
      updateRechargeCards(null);
      console.log("###Result:", res.data);
      let msg = "";
      if (res && res.data && res.data.msgCode) {
        msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.data.msgCode
        );
      }
      clearAlerts();
      if (!msg) {
        msg = "Items successfully added to cart";
      }
      setAlert(msg, res.status === "ERROR" ? "danger" : "info");
      setItemsInCart(true);
      setShowDialog(true);
    } catch (err) {
      console.log("###Error: ", err);
      // clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  useEffect(() => {
    if (cartLoaded === true && !error) {
      loadItems({}, token);
    }
    //eslint-disable-next-line
  }, [itemsInCart]);

  const postSaveToCart = () => {
    setShowDialog(false);
    history.push("/user-cart");
  };
  const searchByList = [
    {
      name: "employeeid",
      displayName: "Employee ID",
      requireInput: true,
    },
    {
      name: "employeename",
      displayName: "Employee Name",
      requireInput: true,
    },
    {
      name: "groupname",
      displayName: "Group Name",
      requireInput: true,
    },
    {
      name: "contractname",
      displayName: "Contract",
      requireInput: true,
    },
    {
      name: "cardnumber",
      displayName: "Card Number",
      requireInput: true,
    },
  ];
  const columnDefs = [
    {
      Header: "Emp ID",
      accessor: "employeeId",
      className: "drillColumn",
      customCell: "action",
      onClickAction: (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        console.log(`Clicked for(${rowIndex},${columnId}) :`, value);
        selectCurrentEmployee(rowIndex);
      }, // This is a custom function that we supplied to our table instance
      fieldType: "link",
    },
    {
      Header: "Emp Name",
      accessor: "empName",
    },
    {
      Header: "Group Name",
      accessor: "groupName",
    },
    {
      Header: "Contract",
      accessor: "contract",
      className: "drillColumn",
      customCell: "action",
      onClickAction: (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        console.log(`Clicked for(${rowIndex},${columnId}) :`, value);
        selectCurrentContract(rowIndex);
      }, // This is a custom function that we supplied to our table instance
      fieldType: "link",
    },
    {
      Header: "Card Number",
      accessor: "cardNumber",
      className: "drillColumn",
      customCell: "action",
      onClickAction: (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        console.log(`Clicked for(${rowIndex},${columnId}) :`, value);
        selectCurrentCard(value);
      }, // This is a custom function that we supplied to our table instance
      fieldType: "link",
    },
    {
      Header: "Status",
      accessor: "status",
      filter: "text",
    },
    {
      Header: "Amount",
      accessor: "amount",
      customCell: "editable",
    },
  ];

  // const onPopulateAllChange = (e) => {
  //   e.preventDefault();
  //   setRechargeValueAll(e.target.value);
  // };

  const [applyAll, setApplyAll] = useState(false);

  const populateAll = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    console.log("CARD DATA:", cardData, filteredRows);
    // if (cardData) {
    setCurrentData(() =>
      filteredRows.map((item) => {
        if (item.original.status === "Active")
          item.original.amount = rechargeValueAll;
        // item.status = "updated";
        return item.original;
      })
    );
    setApplyAll(true);
    validateAllTableRows();
    // }
  };

  const clearAll = async (e) => {
    await hasTokenExpired();
    e.preventDefault();

    setCurrentData((cardData) =>
      cardData.map((item) => {
        if (item.status === "Active") item.amount = "";
        return item;
      })
    );
    setApplyAll(true);
    validateAllTableRows();
    // }
  };

  // const data = React.useMemo(() => props.data, [props.data]);
  const [currentData, setCurrentData] = React.useState([]);
  // const [originalData] = React.useState(data);
  const [skipPageReset, setSkipPageReset] = React.useState(false);

  useEffect(() => {
    console.log("CardData from Context", cardData);
    console.log("INit Load", showData);
    if (showData && cardData && cardData.length > 0) {
      setCurrentData(cardData);
      setShowData(false);
    }
    //eslint-disable-next-line
  }, [showData]);

  const updateFieldData = async (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true);
    await setCurrentData((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          };
        }
        return row;
      })
    );
  };

  const getFeildRange = (rowIndex) => {
    const rec = currentData
      .filter((item, index) => index === rowIndex)
      .map((item) => {
        console.log("Record Item:", item);
        return [
          (item.minValue / 100).toFixed(2),
          (item.maxValue / 100).toFixed(2),
          461,
          item.employeeId,
        ];
      })[0];
    console.log("Record Item:", rec);
    return rec;
  };

  const validateAllTableRows = () => {
    let noData = true;
    for (let i = 0; i < currentData.length; i++) {
      if (currentData[i].status === "Active") {
        let [minVal, maxVal] = getFeildRange(i);
        let rechargeValue = parseFloat(currentData[i].amount);
        if (currentData[i].amount !== "" && rechargeValue !== 0) {
          noData = false;
          console.log("NoData -->", currentData[i].amount);
          minVal = parseFloat(minVal);
          maxVal = parseFloat(maxVal);
          if (rechargeValue >= minVal && rechargeValue <= maxVal) {
            setIsTableValid(true);
          } else {
            setIsTableValid(false);
            return;
          }
        }
      }
    }
    console.log("NoData", noData);
    if (noData) {
      setIsTableValid(false);
    }
    console.log("IS TABLE VALID??", isTableValid);
  };

  const validateInputField = async (rowIndex, columnId, value, ctrlRef) => {
    // console.log("Custom Field", columnId);
    // console.log("Custom value", value);
    // console.log("Inout Control", ctrlRef);
    if (value) {
      let [minVal, maxVal, msgCode, empId] = getFeildRange(rowIndex);
      console.log("Custom Field Min", minVal, " Max ", maxVal, "Val ", value);
      value = parseFloat(value);
      let res = !(value >= minVal && value <= maxVal)
        ? getConfigValueByCode("generalConfig", "RESPONSE_MSG", msgCode)
        : "";
      if (res) {
        res = res.replace("{0}", minVal);
        res = res.replace("{1}", maxVal);
        res = res.replace("{2}", empId);
      }
      // console.log("Custom Field res", res);
      //check the value is within the range
      if (res) {
        ctrlRef.current.className = "wrong-input";
        setValidationMessage(res);
        setFieldRef(ctrlRef);
        // setShowTooltip(true);
        displayTooltip();
      } else {
        ctrlRef.current.className = "";
        setValidationMessage("");
        setFieldRef(null);
        setShowTooltip(false);
      }
    }
    // return res;
    validateAllTableRows();
  };

  const displayTooltip = () => {
    setShowTooltip(true);
    // const intervalID = setInterval(setShowTooltip(true), 5000);
    setTimeout(() => {
      setShowTooltip(false);
      // clearInterval(intervalID);
    }, msgDisplayTime);
  };

  React.useEffect(() => {
    setSkipPageReset(false);
    updateChangedData(currentData);
    //eslint-disable-next-line
  }, [currentData]);

  const [labels, setLabels] = useState({
    rsRechargeAmount: "",
  });
  useEffect(() => {
    console.log("checking navigation", navigationBack);
    if (navigationBack) {
      console.log("setingInitLoad", true);
      setShowData(true);
      resetNavigationState();
    } else {
      console.log("RESETing RS Recharge");
      // setShowData(false);
      resetCardState();
      setCurrentData([]);
      clearAlerts();
    }
    let rsRechargeAmount = getConfigValueByNameSponser(
      "generalConfig",
      "Label",
      "label.rsRechargeAmount"
    );
    setLabels({ ...labels, rsRechargeAmount });
    //eslint-disable-next-line
  }, []);

  const onRechargeAllValueChange = (value, feildmane) => {
    console.log("Recharge Amount", value);
    if (!value || parseFloat(value) === 0) {
      return "Reload Amount can not be blank";
    } else return "";
  };

  const { Popup, validateField, setUnformattedValues } = useForm({
    inputList: {
      rechargeValueAll: rechargeAmountRef,
    },
    screenName: "sponser_subscription_management",
    unformattedValuesList: {
      rechargeValueAll: 0.0,
    },
    customRules: {
      rechargeValueAll: onRechargeAllValueChange,
    },
    excludePrefix: {
      rechargeValueAll: true,
    },
  });

  const getFilteredRows = (rows) => {
    function objectsAreSame(x, y) {
      console.log(
        "getFilteredRows objectsAreSame",
        x.original.employeeId,
        y.original.employeeId
      );
      var objectsAreSame = true;
      if (x.original.employeeId !== y.original.employeeId) {
        objectsAreSame = false;
      } else {
        return objectsAreSame;
      }
    }

    const arraysEqual = (a1, a2) =>
      a1 &&
      a2 &&
      a1.length === a2.length &&
      a1.every((o, idx) => objectsAreSame(o, a2[idx]));

    console.log(
      "getFilteredRows change",
      filteredRows && rows && !arraysEqual(filteredRows, rows),
      filteredRows
    );

    if (!arraysEqual(filteredRows, rows)) {
      setFilteredRows(rows);
    }
  };

  const [tableAlert, setTableAlert] = useState(" ");
  console.log("setTableAlert", tableAlert);

  return (
    <Fragment>
      {/* <RechargePopup /> */}
      <Popup />
      <TablePopup />
      {showDialog && (
        <ModalDialog
          show={showDialog}
          onClose={onClose}
          onSubmit={postSaveToCart}
          title={"Confirmation"}
          message={
            "Click 'Continue' to proceed to cart. OR Click 'Stay Back' to stay on the page to add more items"
          }
          cancelLabel={"Stay Back"}
          submitLabel={"Continue"}
          role="modal"
        />
      )}
      {(rechargeLoading || isLoading || cartLoading || employeesLoading) && (
        <Preloader />
      )}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronPage"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <div className="patronPage__titleBar">
          <h1 id="pageHeader" className="patronPage__pageTitle">
            RELOAD CARD
          </h1>
          <div className="patronPage__pageTitle__note">
            {/* <span className="required">*</span>denotes a required field */}
          </div>
        </div>
        <div className="patronPage__content">
          <div className="patronPage__searchBar">
            <SearchMenu
              onSearch={searchCards}
              searchByList={searchByList}
              includePeriod={false}
            />
          </div>
          <div className="patronPage__applyAllBar">
            <Form noValidate className="patronPage__applyAllForm">
              <Form.Group as={Row} className="patronPage__applyAllFormRow">
                <Col md="4">
                  <Form.Label htmlFor="rechargeValueAll">
                    {labels.rsRechargeAmount}{" "}
                    <span className="required" aria-label="Input required">
                      (*Required)
                    </span>
                    :{" "}
                  </Form.Label>
                </Col>
                <Col md="2">
                  <NumberFormat
                    className="mb-2  form-control"
                    id="rechargeValueAll"
                    name="rechargeValueAll"
                    placeholder="$0.00"
                    value={rechargeValueAll}
                    onValueChange={(values) => {
                      setRechargeValueAll(values.value);
                      setUnformattedValues({
                        rechargeValueAll: values.floatValue,
                      });
                    }}
                    prefix={"$"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    isNumericString={true}
                    getInputRef={rechargeAmountRef}
                    onBlur={validateField}
                  />
                </Col>
                <Col md="auto"></Col>
                <Col md="auto" className="justify-content-md-center">
                  <Button
                    className="mb-2"
                    id="btnClearAll"
                    name="btnClearAll"
                    aria-label="POPULATE ALL "
                    onClick={populateAll}
                    disabled={
                      !rechargeValueAll || parseFloat(rechargeValueAll) === 0
                    }
                  >
                    POPULATE ALL
                  </Button>
                </Col>

                <Col md="auto" className="justify-content-md-center">
                  <Button
                    aria-label="CLEAR ALL "
                    className="mb-2"
                    id="btnClearAll"
                    name="btnClearAll"
                    onClick={clearAll}
                    disabled={!(currentData && currentData.length > 0)}
                  >
                    CLEAR ALL
                  </Button>
                </Col>
              </Form.Group>
            </Form>
          </div>
          <div
            aria-live="polite"
            style={{ color: "transparent", height: "1px" }}
          >
            {tableAlert}
          </div>
          {!showData && currentData && currentData.length > 0 && (
            <div className="patronPage__tableListing">
              <DataInputTable
                data={currentData}
                columnDefs={columnDefs}
                pages={pages}
                pageSize={pageSize}
                loadPageData={loadPageData}
                tableAction="SAVE TO CART"
                onTableAction={onSaveToCart}
                applyAll={applyAll}
                updateFieldData={updateFieldData}
                validateField={validateInputField}
                skipPageReset={skipPageReset}
                isTableAction={isTableValid}
                getFilteredRows={getFilteredRows}
              />
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default SponsorRecharge;
